import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { store } from '@/store';
import { theme } from '@/styles';
import { AppRouter } from '@/router';
import { Header } from '@/components';
import { msalInstance } from '@/auth';
import { MsalProvider } from '@azure/msal-react';
import '@/locales';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
              }}
            >
              <Header />
              <Box sx={{ flex: 1 }}>
                <AppRouter />
              </Box>
            </Box>
          </BrowserRouter>
        </ThemeProvider>
      </MsalProvider>
    </Provider>
  );
};

export default App;
